import { render, staticRenderFns } from "./sc-item.vue?vue&type=template&id=3eb3d38e&scoped=true&"
import script from "./sc-item.vue?vue&type=script&lang=js&"
export * from "./sc-item.vue?vue&type=script&lang=js&"
import style0 from "./sc-item.vue?vue&type=style&index=0&id=3eb3d38e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb3d38e",
  null
  
)

export default component.exports